module.exports = __webpack_public_path__ + "static/media/module3-female.72b978d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/module3-female.mp4
// module id = 2EIv
// module chunks = 0